import React, { useState,useRef,useEffect }  from 'react';
import { Popconfirm, message, Button, ConfigProvider,Dropdown,Menu,Popover} from 'antd';
import { EditOutlined,DeleteOutlined,PlusOutlined,EllipsisOutlined,UnorderedListOutlined } from '@ant-design/icons';
import { ProTable } from '@ant-design/pro-components';
import EditModel from './components/edit';
import OrderCand from './components/orderCand.jsx';
import OplogModel from '../components/oplog.jsx';
import {api_tenant_list, api_order_list, api_status_list, api_interviewer_list, api_position_list,api_user_list, api_order_edit_status} from '../../api';
import routes from '../../menuRoute/index';
import { localStorageGet,waitTime } from '../../utils/global.js';
// import JSZip from 'jszip';
// import { saveAs } from 'file-saver';
import zhCN from 'antd/lib/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn')

function getDateStr(AddDayCount) {
  var dd = new Date();
  dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
  var year = dd.getFullYear();
  var mon = dd.getMonth() + 1; //获取当前月份的日期
  var day = dd.getDate();
  return year + '-' + (mon < 10 ? ('0' + mon) : mon) + '-' + (day < 10 ? ('0' + day) : day);
}
// var startTime=getDateStr(-6);
// var endTime=getDateStr(0);

export default () => {
  const actionRef = useRef();

  const [showModal, setShowModal] = useState(false);
  const [rowInfo, setRowInfo] = useState({});
  const [pagination, setPagination] = useState({current:1,pageSize:10,total:0});
  const [pageSize, setPageSize] = useState(10);
  /*** @zh-CN 所有页面列表 *  */
  const [treeMenus, setTreeMenus] = useState([]);
  /*** @zh-CN 已选中列表 *  */
  const [tenantList, setTenantList] = useState([]);
  const [orderStatusList, setOrderStatusList] = useState([]);
  const [orderStatusEnum, setOrderStatusEnum] = useState({});
  const [orderStatusSearchList, setOrderStatusSearchList] = useState([]);
  const [orderStatusSearchEnum, setOrderStatusSearchEnum] = useState({});
  const [invitationStatusList, setInvitationStatusList] = useState([]);
  const [invitationStatusEnum, setInvitationStatusEnum] = useState({});
  const [candidatesStatusList, setCandidatesStatusList] = useState([]);
  const [candidatesStatusEnum, setCandidatesStatusEnum] = useState({});
  const [interviewMethodList, setInterviewMethodList] = useState([]);
  const [interviewMethodEnum, setInterviewMethodEnum] = useState({});
  const [meetingMethodList, setMeetingMethodList] = useState([]);
  const [meetingMethodEnum, setMeetingMethodEnum] = useState({});
  const [priorOptionList, setPriorOptionList] = useState([]);
  const [priorOptionEnum, setPriorOptionEnum] = useState({});
  const [interviewList, setInterviewList] = useState([]);
  const [interviewEnum, setInterviewEnum] = useState({});
  const [positionList, setPositionList] = useState([]);
  const [positionEnum, setPositionEnum] = useState({});
  const [showCandidate, setShowCandidate] = useState(false);
  const [backUserList, setBackUserList] = useState([]);
  const [backUserEnum, setBackUserEnum] = useState({});
  const [orderCreatUserEnum, setOrderCreatUserEnum] = useState({});
  const [tenantInfo, setTenantInfo] = useState({});
  const [showOplogModal, setShowOplogModal] = useState(false);

  const currentUserinfo = localStorageGet('UserInfo_k');
  console.log('========order list currentUserinfo==========', currentUserinfo)

  useEffect(() => {
    if (routes) {
      let menus= getTreeNodes(routes);
      console.log(menus);
      setTreeMenus(menus);
    }
    // getTenantslist();
    getStatusList();
    getInterviewerList();
    getPositionList();
    getBackUserList();
  }, []);
  
  const closeModal = () =>{
    setShowModal(false);
    setShowCandidate(false);
    setShowOplogModal(false);
  }

  const getTreeNodes = (list) => {
    console.log(list)
    let arr = [];
    list.forEach((item)=>{
        // if(item.name && (!item.hideInMenu)){
        if(item.title){
            if(item.children){
              let child=[]
                arr.push({title:item.title,key:item.path,children:getTreeNodes(item.children)})
            }else{
                arr.push({title:item.title,key:item.path})
            }
        }else{
            if(item.children){
                getTreeNodes(item.children)
            }
        }
    });
    return arr
    // if(arr.length !== 0) setTreeData(arr);
 }

 
  // 获取租户列表
  const getTenantslist = async ()=>{
    try {
      api_tenant_list({}).then((res) => {
        console.log('api_tenant_list-res-----------------', res);
        // var flag = checkLogin('A', res.data)
        if (res.data.code == 9) {
          var list = [{value:'', label:"--请选择--"}];
          for(let item of res.data.list){
            list.push({value:item.tenant_id, label:item.tenant_name});
          }
          console.log('list ------- ',list)
          setTenantList(list);
        }else
          message.error(res.data.msg);
      });
    } catch (error) {
      console.log('catch-error------------', error)
      // return false;
    }

  }
 
  // 获取状态列表
  const getStatusList = async ()=>{
    try {
      api_status_list({}).then((res) => {
        console.log('api_status_list-res-----------------', res);
        // var flag = checkLogin('A', res.data)
        if (res.data.code == 9) {
          // 订单状态
          var status = [];
          var senum = {};
          for(let item of res.data.list.order_status){
            status.push(item);
            senum[item.value] = {
              text:item.label, 
              status:item.status, 
              color:item.color,
              edit:item.edit,
              pause:item.pause,
              cancel:item.cancel,
              stop:item.stop,
              restart:item.restart,
            };
          }
          console.log('=====orderStatusEnum=======', senum)
          setOrderStatusEnum(senum);
          setOrderStatusList(status);
          // 订单搜索状态
          status = [];
          senum = {};
          for(let item of res.data.list.order_status_search){
            status.push(item);
            senum[item.value] = {text:item.label};
          }
          setOrderStatusSearchEnum(senum);
          setOrderStatusSearchList(status);
          // 邀约状态
          status = [];
          senum = {};
          for(let item of res.data.list.invitation_status){
            status.push(item);
            senum[item.value] = {
              text:item.label,
              status:item.status, 
              color:item.color,
              edit:item.edit,
              pause:item.pause,
              cancel:item.cancel,
              stop:item.stop,
              restart:item.restart,
            };
          }
          setInvitationStatusEnum(senum);
          setInvitationStatusList(status);
          // 候选人状态
          status = [];
          senum = {};
          for(let item of res.data.list.candidates_status){
            status.push(item);
            senum[item.value] = {text:item.label, status:item.status, color:item.color};
          }
          setCandidatesStatusEnum(senum);
          setCandidatesStatusList(status);
          // 面试方式
          status = [];
          senum = {};
          for(let item of res.data.list.interview_method){
            status.push(item);
            senum[item.value] = {text:item.label};
          }
          setInterviewMethodEnum(senum);
          setInterviewMethodList(status);
          // 优先选项
          status = [];
          senum = {};
          for(let item of res.data.list.prior_option){
            status.push(item);
            senum[item.value] = {text:item.label};
          }
          setPriorOptionEnum(senum);
          setPriorOptionList(status);
          // 会议软件
          status = [];
          senum = {};
          for(let item of res.data.list.meeting_method){
            status.push(item);
            senum[item.value] = {text:item.label};
          }
          setMeetingMethodEnum(senum);
          setMeetingMethodList(status);
        }else
          message.error(res.data.msg);
      });
    } catch (error) {
      console.log('catch-error------------', error)
      // return false;
    }

  }
 
  // 获取面试官列表
  const getInterviewerList = async ()=>{
    try {
      api_interviewer_list({}).then((res) => {
        console.log('api_interviewer_list-res-----------------', res);
        // var flag = checkLogin('A', res.data)
        if (res.data.code == 9) {
          var status = [];
          var senum = {};
          for(let item of res.data.list){
            // status.push({value:item.interviewer_id, label:item.name});
            status.push(item);
            senum[item.interviewer_id] = {text:item.name, phone:item.phone, email:item.email};
          }
          setInterviewEnum(senum);
          setInterviewList(status);
        }else
          message.error(res.data.msg);
      });
    } catch (error) {
      console.log('catch-error------------', error)
      // return false;
    }

  }
  
  // 获取岗位列表
  const getPositionList = async ()=>{
    try {
      api_position_list({}).then((res) => {
        console.log('api_position_list-res-----------------', res);
        // var flag = checkLogin('A', res.data)
        if (res.data.code == 9) {
          var status = [];
          var senum = {};
          for(let item of res.data.list){
            status.push({value:item.name, label:item.name});
            senum[item.id] = {text:item.name};
          }
          setPositionEnum(senum);
          setPositionList(status);
        }else
          message.error(res.data.msg);
      });
    } catch (error) {
      console.log('catch-error------------', error)
      // return false;
    }
  }

  // 获取后备联络人列表
  const getBackUserList = async ()=>{
    try {
      await api_user_list({type:"back"}).then((res) => {
        console.log('api_user_list-res-----------------', res);
        // var flag = checkLogin('A', res.data)
        if (res.data.code == 9) {
          var list = [];
          var senum = {};
          for(let item of res.data.list){
            list.push({value:item.id, label:item.username});
            senum[item.id] = {text:item.username};
          }
          console.log( 'getBackUserList ---senum------ ', senum)
          console.log( 'getBackUserList ----list----- ', list)
          setBackUserEnum(senum);
          setBackUserList(list);
        }else
          message.error(res.data.msg);
      });
    } catch (error) {
      console.log('catch-error------------', error)
      // return false;
    }

  }

  // 刷新列表
  const refreshlist = async ()=>{
    getInterviewerList();
    getPositionList();
    actionRef.current?.reload();
  }

  // 修改工单状态
  const editStatus = (id,action)=>{
    console.log(id,action)
    try {
      api_order_edit_status({id:id, action:action}).then((res) => {
        console.log('api_order_edit_status-res-----------------', res);
        if (res.data.code == 9) {
          if(res.data.msg)
            message.error("工单操作完成。但是"+res.data.msg);
          else
            message.success("操作成功");
          refreshlist();
        }else
          message.error(res.data.msg);
      });
      } catch (error) {
        message.error("网络异常");
        return false;
      }
  }

  let columns = [
    {
      title: '工单ID',
      dataIndex: 'work_order_id',
      search:false,
      key:"work_order_id",
      width: 220,
      ellipsis: true,
    },
    {
      title:'创建时间',
      dataIndex: 'creat_time',
      valueType: "dateRange",
      width: 150,
      key:"creat_time",
      order: 4,
      fieldProps: {
        picker: "date",
        format:'YYYY-MM-DD',
        allowClear:true,
        // defaultValue:[moment(startTime), moment(endTime)]
      },
      render: (_,record) => {
        return record.creat_time
      }
    },
    {
      title: '面试官',
      dataIndex: 'interviewer_id',
      // search:false,
      order: 3,
      key:"interviewer_id",
      width: 100,
      ellipsis: true,
      valueType: 'select',
      valueEnum: interviewEnum,
    },
    // {
    //   title: '可用面试时间',
    //   dataIndex: 'avl_intv_time',
    //   search:false,
    //   key:"avl_intv_time",
    //   width: 150,
    //   ellipsis: true,
    //   render: (_,record) => {
    //     if(record.avl_intv_time){
    //       var times = JSON.parse(record.avl_intv_time);
    //       console.log('-------times--------', times)
    //       var showtimes = [];
    //       for(let t of times){
    //         showtimes.push(t[0]+" - "+t[1]);
    //       }
    //       // return showtimes.join("\n");
    //       var text = showtimes.join("\n");

    //       var content = showPopTime(times);
    //       console.log('----------------content-------------', content)
    //       return (
    //         <Popover content={showPopTime(times)} color="rgb(64,64,64)" key="rgb(64,64,64)" >
    //           <span style={{ maxWidth: 130, display: 'inline-block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
    //             {text}
    //           </span>
    //         </Popover>
    //       );
          
    //     }
    //     else
    //       return '-';
    //   }

    // },
    {
      title: '是否授权日历安排',
      dataIndex: 'ai_auto_time',
      search:false,
      key:"ai_auto_time",
      width: 130,
      valueType: 'select',
      valueEnum: {
        "0": {
          text: '否',
          // status: 'Processing',
        },
        "1": {
          text: '是',
          // status: 'Success',
          // disabled: true,
        },
      },
    },
    {
      title: '启动时间',
      dataIndex: 'execute_time',
      search:false,
      ellipsis: true,
      key:"execute_time",
      width: 150,
    },
    {
      title: '工作岗位',
      dataIndex: 'position_id',
      // search:false,
      order:2,
      key:"position_id",
      width: 100,
      ellipsis: true,
      valueType: 'select',
      valueEnum: positionEnum,
    },
    {
      title: '候选人',
      dataIndex: 'candidates',
      key: 'candidates',
      search: false,
      // ellipsis: true,
      width: 80,
      render: (text, record, _, action) => [
        // "13244687914",' ',"柴鑫","\n","18145503713",' ',"ascnv"
        <UnorderedListOutlined 
          onClick={()=>{
            setRowInfo(record);
            setShowCandidate(true);
          }} />
      ]
    },
    {
      // disable: true,
      width: 100,
      title: '工单类别',
      dataIndex: 'stype',
      // search:false,
      order: 5,
      hideInTable: true,
      key:"stype",
      ellipsis: true,
      valueType: 'select',
      valueEnum: orderStatusSearchEnum,
    },
    {
      // disable: true,
      width: 100,
      title: '状态',
      dataIndex: 'status',
      search:false,
      key:"status",
      ellipsis: true,
      valueType: 'select',
      valueEnum: orderStatusEnum,
    },
    {
      // disable: true,
      width: 100,
      title: '面试方式',
      dataIndex: 'interview_method',
      search:false,
      key:"interview_method",
      ellipsis: true,
      valueType: 'select',
      valueEnum: interviewMethodEnum,
    },
    // {
    //   title: '面试地点',
    //   dataIndex: 'interview_location',
    //   search:false,
    //   key:"interview_location",
    //   width: 100,
    //   ellipsis: true,
    // },
    // {
    //   title: '避开午休',
    //   dataIndex: 'avoid_noon',
    //   search:false,
    //   key:"avoid_noon",
    //   width: 130,
    //   valueType: 'select',
    //   valueEnum: {
    //     "0": {
    //       text: '否',
    //       // status: 'Processing',
    //     },
    //     "1": {
    //       text: '是',
    //       // status: 'Success',
    //       // disabled: true,
    //     },
    //   },
    // },
    // {
    //   title: '午休时间',
    //   dataIndex: 'noon_time',
    //   search:false,
    //   key:"noon_time",
    //   width: 100,
    //   ellipsis: true,
    // },
    {
      // disable: true,
      width: 100,
      title: '安排方式',
      dataIndex: 'prior_option',
      search:false,
      key:"prior_option",
      ellipsis: true,
      valueType: 'select',
      valueEnum: priorOptionEnum,
    },
    {
      title: '面试时长',
      dataIndex: 'duration',
      search:false,
      key:"duration",
      width: 100,
      ellipsis: true,
    },
    {
      // disable: true,
      width: 100,
      title: '创建人',
      dataIndex: 'creat_userid',
      // search:false,
      order:1,
      key:"creat_userid",
      ellipsis: true,
      valueType: 'select',
      valueEnum: orderCreatUserEnum,
    },
    {
      // disable: true,
      width: 100,
      title: '后备联络人',
      dataIndex: 'back_userid',
      search:false,
      key:"back_userid",
      ellipsis: true,
      valueType: 'select',
      valueEnum: backUserEnum,
    },
    {
      title: '操作记录',
      dataIndex: 'oplog',
      key: 'oplog',
      search: false,
      // ellipsis: true,
      width: 80,
      render: (text, record, _, action) => [
        // "13244687914",' ',"柴鑫","\n","18145503713",' ',"ascnv"
        <UnorderedListOutlined 
          onClick={()=>{
            setRowInfo(record);
            setShowOplogModal(true);
          }} />
      ]
    },
];
  if(currentUserinfo.roleid=='2')
    columns.push({
      title: '操作',
      valueType: 'option',
      width: 80,
      key: 'option',
      render: (text, record, _, action) => !orderStatusEnum.hasOwnProperty(record.status)?[]:[
        orderStatusEnum[record.status].edit=='1'?
        <a  key={"edita"+record.tenant_id}
          onClick={async() => {
            console.log('record ------------- ', record)
            console.log('action ------------- ', action)
            // action?.startEditable?.(record.id);
            record.interviewer_name = interviewEnum[record.interviewer_id].text;
            record.interviewer_phone = interviewEnum[record.interviewer_id].phone;
            record.interviewer_email = interviewEnum[record.interviewer_id].email;
            record.position_name = positionEnum[record.position_id].text;
            setRowInfo(record);
            await waitTime(100);
            setShowModal(true);
          }}
        >
          <EditOutlined  key={"edit"+record.tenant_id}
            style={{backgroundColor:"rgb(24,188,156)",padding:"2px 3px",borderRadius:3,color:"white"}} />
        </a>:
          <EditOutlined  key={"edit"+record.tenant_id}
            style={{backgroundColor:"#ccc",padding:"2px 3px",borderRadius:3,color:"white",cursor:"not-allowed"}} />
        ,
        // record.roleid!=99 && 
        // <Popconfirm  key={"delpop"+record.tenant_id}
        //   title="确定删除吗?" onConfirm={() => {delComp(record.cid)}}>
        //   <DeleteOutlined  key={"del"+record.tenant_id}
        //     style={{backgroundColor:"#ff4d4f",padding:"2px 3px",borderRadius:3,color:"white"}} />
        // </Popconfirm>,
        orderStatusEnum[record.status].stop!='1' && orderStatusEnum[record.status].cancel!='1' && orderStatusEnum[record.status].pause!='1' && orderStatusEnum[record.status].restart!='1' ? 
        <EllipsisOutlined  style={{color:"#ccc",fontSize:20,cursor:"not-allowed"}}/>:
        <Dropdown overlay={()=>{
          return(
          <Menu style={{borderRadius:8,}} >
            <Menu.Item 
              style={{display: orderStatusEnum[record.status].stop=='1'?'block':'none'}}
              onClick={()=>{editStatus(record.id, "stop")}}>终止
            </Menu.Item> 
            <Menu.Item 
              style={{display: orderStatusEnum[record.status].cancel=='1'?'block':'none'}}
              onClick={()=>{editStatus(record.id, "cancel")}}>取消
            </Menu.Item> 
            <Menu.Item 
              style={{display: orderStatusEnum[record.status].pause=='1'?'block':'none'}}
              onClick={()=>{editStatus(record.id, "pause")}}>暂停
            </Menu.Item> 
            <Menu.Item 
              style={{display: orderStatusEnum[record.status].restart=='1'?'block':'none'}}
              onClick={()=>{editStatus(record.id, "restart")}}>重启
            </Menu.Item> 
            {/* <Popconfirm
                title="确认删除该工单？"
                onConfirm={()=>{
                  // delClient(data.id);
                }}
                okText="Yes"
                cancelText="No"
            >
              <Menu.Item 
                  // style={{display:isShow('del')?'block':'none'}}
              >删除工单</Menu.Item> 
            </Popconfirm> */}
            
          </Menu>
          )}}>
          <EllipsisOutlined  style={{color:"rgb(63,140,255)",fontSize:20}}/>
        </Dropdown>
      // <a href={record.url} target="_blank" rel="noopener noreferrer" key="view">
        //   查看
        // </a>,
        // <TableDropdown
        //   key="actionGroup"
        //   onSelect={() => action?.reload()}
        //   menus={[
        //     { key: 'copy', name: '复制' },
        //     { key: 'delete', name: '删除' },
        //   ]}
        // />,
      ],
    });

   
  return (
    <ConfigProvider locale={zhCN}>
    <div>
          
    <ProTable
      headerTitle="工单列表"
      columns={columns}
      actionRef={actionRef}
      rowKey="id"
      cardBordered
      defaultSize="small"
      request={async (params, sort, filter) => {
        console.log(params,sort, filter);
        // if(!params.creat_time)
        //   params.creat_time = [startTime, endTime];

        // await waitTime(2000);
        var tableData = [];
        var res = await api_order_list(params);
        console.log('api_order_list-res-----------------', res);
        if(res.data.code == 9){
          var enums = {};
          for(let v of res.data.userlist)
            enums[v.id] = {text:v.username};
          console.log('------------enums--------------', enums)
          setOrderCreatUserEnum(enums);
          waitTime(100);
          tableData = res.data.list;
          setPagination({current:parseInt(res.data.pageinfo.current), pageSize:parseInt(res.data.pageinfo.pageSize), total:parseInt(res.data.pageinfo.total)})
          setTenantInfo(res.data.tenantinfo);
        }else
          message.error(res.data.msg);

        return {
          data: tableData,
          // current: res.data.pageNo,
          // pageSize: res.data.pageSize,
          success: true,
          // total: res.data.totalRows,
        };
      }}
      search={{
        labelWidth: 'auto',
      }}
      options={{
        reload: false, // 去掉刷新按钮
        density: false, // 去掉密度按钮
        setting: true, // 保留列设置按钮
        setting: {
          listsHeight: 400,
        },
      }}
      style={{lineHeight: '0.40rem',marginTop:'0.32rem',overflowX: 'scroll',overflowY: 'scroll'}}  
      scroll={{x:1000}}
      columnsState={{
        persistenceKey: 'pro-table-order',
        persistenceType: 'localStorage',
        onChange(value) {
          console.log('value: ', value);
        },
      }}

      // form={{
      //   // 由于配置了 transform，提交的参与与定义的不同这里需要转化一下
      //   syncToUrl: (values, type) => {
      //     if (type === 'get') {
      //       return {
      //         ...values,
      //         created_at: [values.startTime, values.endTime],
      //       };
      //     }
      //     return values;
      //   },
      // }}
      pagination={{
        // pageSizeOptions: [10, 20, 50, 100, pagination.total],
        showSizeChanger: true,
        pageSize: pagination.pageSize,
        current:pagination.current,
        total:pagination.total,
        onChange: (page) => console.log(page),
      }}

      // dateFormatter="string"

      toolBarRender={() => [
        <Button
          key="button"
          icon={<PlusOutlined />}
          // style={{backgroundColor:"rgb(5,168,137)"}}
          onClick={async() => {
            setRowInfo({});
            await waitTime(100);
            setShowModal(true);
          }}
          type="primary"
          disabled={currentUserinfo.roleid=='99'||currentUserinfo.roleid=='1'?true:false}
          // style={{display: currentUserinfo.roleid=='2'?"block":"none"}}
        >
          新建工单
        </Button>,
      ]}
    />

    <EditModel
      showModal={showModal}
      closeModal={closeModal}
      rowInfo={rowInfo}
      refreshlist={refreshlist}
      interviewMethodList={interviewMethodList}
      positionList={positionList}
      priorOptionList={priorOptionList}
      interviewList={interviewList}
      backUserList={backUserList}
      meetingMethodList={meetingMethodList}
      tenantInfo={tenantInfo}
    />

    <OrderCand
      showModal={showCandidate}
      rowInfo={rowInfo}
      closeModal={closeModal}
      invitationStatusEnum={invitationStatusEnum}
      candidatesStatusEnum={candidatesStatusEnum}
    />

    <OplogModel
      showModal={showOplogModal}
      rowInfo={rowInfo}
      closeModal={closeModal}
      from={"order"}
    />

    </div>
    </ConfigProvider>
  );
};